import { z } from "zod";

export const agaveEvalListKindSchema = z.enum([
  "harbor-chat",
  "chat",
  "chat-mfx",
  "chat-creation",
  "creation",
  "ai-edit-fx",
  "creation-live",
  "fx-creation",
  "fx-creation-mfx",
]);
export type AgaveEvalListKind = z.infer<typeof agaveEvalListKindSchema>;

const evalProfileByListKind: Partial<Record<AgaveEvalListKind, string>> = {
  chat: "chat-regular-trials1-sha-image-deployment-v1",
  "chat-mfx": "chat-mfx-trials1-sha-image-deployment-v1",
  "chat-creation": "chat-creation-medium-trials1-sha-image-deployment-v1",
  "fx-creation": "creation-regular-trials1-sha-image-deployment-v1",
  "fx-creation-mfx": "creation-mfx-trials1-sha-image-deployment-v1",
};

const creationWorkflowByListKind: Partial<Record<AgaveEvalListKind, string>> = {
  "chat-creation": "fx_project",
  "fx-creation": "fx_project",
  "fx-creation-mfx": "fx_project",
};

export function agaveEvalProfileForListKind(kind: AgaveEvalListKind) {
  return evalProfileByListKind[kind];
}

export function agaveEvalCreationWorkflowForListKind(kind: AgaveEvalListKind) {
  return creationWorkflowByListKind[kind];
}

export function agaveEvalSuiteForListKind(kind: AgaveEvalListKind) {
  if (kind === "harbor-chat") {
    return "chat";
  }
  if (kind === "ai-edit-fx") {
    return "ai_edit_fx";
  }
  if (isCreationSuiteEvalListKind(kind)) {
    return "creation";
  }
  if (kind === "creation") {
    return "ai_edit";
  }
  return;
}

export function isChatSuiteEvalListKind(kind: AgaveEvalListKind) {
  return kind === "harbor-chat" || kind === "chat" || kind === "chat-mfx";
}

export function isCreationSuiteEvalListKind(kind: AgaveEvalListKind) {
  return kind === "chat-creation" || kind === "fx-creation" || kind === "fx-creation-mfx";
}

export function agaveEvalListKindLabel(kind: AgaveEvalListKind) {
  if (kind === "harbor-chat") {
    return "Harbor Chat";
  }
  if (kind === "chat") {
    return "Chat Regular";
  }
  if (kind === "chat-mfx") {
    return "Chat MFX";
  }
  if (kind === "chat-creation") {
    return "Chat Creation";
  }
  if (kind === "creation-live") {
    return "AI Edit (Live)";
  }
  if (kind === "fx-creation") {
    return "Creation Regular";
  }
  if (kind === "fx-creation-mfx") {
    return "Creation MFX";
  }
  if (kind === "ai-edit-fx") {
    return "AI Edit FX";
  }
  return "AI Edit";
}

export function agaveEvalBackLabel(kind: AgaveEvalListKind) {
  return `${agaveEvalListKindLabel(kind)} evals`;
}
